import React from "react";
import {mediaUrl} from "../../utils";

// Photo that fills its (positioned) parent. Takes a public/assets path or a full URL. Shows the caption when no image is set.
const ImageSlot = ({src, alt}) => (
    <div className="pb-image-slot">
        {src ? <img src={mediaUrl(src)} alt={alt || ''} loading="lazy"/> : <span>{alt}</span>}
    </div>
);

export default ImageSlot;
